import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { RECHNER_BY_ID, buildRechnerUrl } from '../lib/rechner';
interface RechnerDetailPageProps {
  rechnerId: string;
  onNavigate: (page: string) => void;
  onBack: () => void;
}
export function RechnerDetailPage({
  rechnerId,
  onNavigate,
  onBack
}: RechnerDetailPageProps) {
  const rechner = RECHNER_BY_ID[rechnerId];
  if (!rechner) {
    return <main className="min-h-screen bg-white dark:bg-slate-950 pt-24 pb-20" data-id="element-844">
        <div className="mx-auto w-full max-w-6xl px-4 text-center" data-id="element-845">
          <h1 className="text-2xl font-semibold text-slate-900 dark:text-white mb-4" data-id="element-846">
            Rechner nicht gefunden
          </h1>
          <Button onClick={onBack} data-id="element-847">
            <ArrowLeft className="mr-2 h-4 w-4" data-id="element-848" />
            Zurück zur Übersicht
          </Button>
        </div>
      </main>;
  }
  const src = buildRechnerUrl(rechner.id);
  return <main className="min-h-screen bg-white dark:bg-slate-950 pt-24 pb-20" data-id="element-849">
      <div className="mx-auto w-full max-w-6xl px-4" data-id="element-850">
        {/* Header */}
        <div className="mb-6 flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4" data-id="element-851">
          <div data-id="element-852">
            {/* Breadcrumb */}
            <div className="mb-2 text-sm text-slate-500 dark:text-slate-400" data-id="element-853">
              <button onClick={onBack} className="hover:text-blue-600 dark:hover:text-blue-400 hover:underline" data-id="element-854">
                ← Alle Rechner
              </button>
              <span className="mx-2" data-id="element-855">/</span>
              <span data-id="element-856">{rechner.category}</span>
            </div>

            <h1 className="text-3xl font-semibold tracking-tight text-slate-900 dark:text-white" data-id="element-857">
              {rechner.label}
            </h1>
            <p className="mt-2 text-slate-500 dark:text-slate-400" data-id="element-858">
              Angaben eingeben, Ergebnisse vergleichen, Favoriten notieren.
              Danach gern gemeinsam einordnen.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex shrink-0 gap-2" data-id="element-859">
            <Button variant="secondary" className="rounded-xl" onClick={() => {
            const el = document.getElementById('rechner');
            el?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-860">
              Zum Rechner springen
            </Button>
            <Button className="rounded-xl" onClick={() => onNavigate('beratung')} data-id="element-861">
              Beratung
            </Button>
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid gap-4 lg:grid-cols-3 mb-6" data-id="element-862">
          <Card className="rounded-2xl dark:bg-slate-900 dark:border-slate-800 lg:col-span-1" data-id="element-863">
            <CardHeader data-id="element-864">
              <CardTitle className="text-base" data-id="element-865">
                So nutzt du den Vergleich
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-2 text-sm text-slate-500 dark:text-slate-400" data-id="element-866">
              <p data-id="element-867">Leistung zuerst einstellen, Beitrag danach feinjustieren.</p>
              <p data-id="element-868">1–2 Favoriten auswählen und Fragen notieren.</p>
              <p data-id="element-869">Bedingungen prüfen: Ausschlüsse, Wartezeiten, Limits.</p>
            </CardContent>
          </Card>

          <Card className="rounded-2xl dark:bg-slate-900 dark:border-slate-800 lg:col-span-2" data-id="element-870">
            <CardHeader data-id="element-871">
              <CardTitle className="text-base" data-id="element-872">Nächster Schritt</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 text-sm text-slate-500 dark:text-slate-400" data-id="element-873">
              <p data-id="element-874">
                Wenn du Favoriten hast, können wir Leistung und Bedingungen
                gemeinsam einordnen.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-875">
                <Button variant="secondary" size="sm" className="rounded-xl" onClick={() => onNavigate('beratung')} data-id="element-876">
                  Beratung anfragen
                </Button>
                <Button variant="outline" size="sm" className="rounded-xl" onClick={() => {
                const el = document.getElementById('rechner');
                el?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} data-id="element-877">
                  Rechner öffnen
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Embedded Calculator */}
        <div id="rechner" className="scroll-mt-24" data-id="element-878">
          <Card className="rounded-2xl dark:bg-slate-900 dark:border-slate-800 overflow-hidden" data-id="element-879">
            <CardContent className="p-0" data-id="element-880">
              <iframe src={src} title={`${rechner.label} Vergleichsrechner`} className="h-[1100px] w-full border-0" style={{
              minHeight: '1100px'
            }} data-id="element-881" />
            </CardContent>
          </Card>
        </div>
      </div>
    </main>;
}